var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuoteinline = function SvgQuoteinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 29,
    fill: "none",
    viewBox: "0 0 26 29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A7B1BE",
    d: "M7.637 14.064H1.756c.1-7.313 1.254-8.519 4.853-11.18.414-.314.551-.971.3-1.504-.238-.517-.777-.689-1.19-.376C1.478 4.136 0 6.046 0 15.144v8.44c0 2.678 1.743 4.838 3.875 4.838h3.762c2.207 0 3.875-2.082 3.875-4.838v-4.698c0-2.74-1.668-4.822-3.875-4.822M21.204 14.064h-5.882c.1-7.313 1.254-8.519 4.854-11.18.413-.314.551-.971.3-1.504-.25-.517-.777-.689-1.203-.376-4.239 3.132-5.719 5.042-5.719 14.156v8.44c0 2.677 1.743 4.838 3.875 4.838h3.762c2.207 0 3.875-2.083 3.875-4.838v-4.698c.013-2.756-1.655-4.839-3.862-4.839"
  })));
};
export default SvgQuoteinline;